import { createContext, useContext } from 'react';

import { Unit } from '~/models/Unit';

const UnitContext = createContext<Unit>(new Unit());

export const useUnitContext = () => useContext(UnitContext);

export default UnitContext;
